import * as ko from 'knockout';

import { viewImages } from '../components/view_image';

/**
 * Opens the image pop-up (with its embedded-metadata panel) when the element is clicked. Takes the
 * image URL, observable or plain; a missing URL leaves the click inert.
 *
 * Usage: `<img data-bind="attr: { src: file_url }, viewImageOnClick: file_url" />`
 */
ko.bindingHandlers['viewImageOnClick'] = {
  init: (element: HTMLElement, valueAccessor: () => ko.MaybeSubscribable<string | null | undefined>) => {
    element.classList.add('clickable');
    element.addEventListener('click', (event) => {
      event.stopPropagation();
      const url = ko.unwrap(valueAccessor());
      if (url) {
        viewImages([url]);
      }
    });
  },
};
